<template>
  <PricingBlock
    :agreement-label="$t('pages.entrance.personal_terms_of_service')"
    agreement-href="https://amaiz.com/files/Amaiz%20Personal%20Account%20Terms.pdf"
    pricing-href="https://amaiz.com/personal/pricing#details"
    :on-accept="onAccept"/>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';

import PricingBlock from '@/modules/onboarding/components/PricingBlock.vue';
import { fetchIndividualApplication, personalOnboardingStoreActions as actions } from '@/stores/OnboardingPersonal';

const router = useRouter();

async function onAccept() {
  await actions.acceptPricing({
    onSuccess: async () => {
      await router.push({ name: 'onboarding-personal-verification' });
    },
  });
}

onMounted(async () => {
  await fetchIndividualApplication();
});

</script>

<style lang="scss">
.pricing {
  @apply w-500;

  &-footer {
    @apply flex flex-col justify-center items-center mt-48 gap-24 mb-40;

    &-agreement {
      @apply w-310 text-center text-n-black-60 text-base font-normal;
    }
  }
}
</style>
